export const colors = {
    abbeyGray: '#525457',
    mediumGray1: '#888888',
    mediumGray2: '#A3A3A3',
    lightGreen: '#E2EFD9',
    aleloGreen: '#bdd753',
    aleloGreenDarker: '#A4C02F',
    backgroundGray: '#E5E5E5',
    backgroundGreen: '#045c46',
    black: '#282828',
    darkGreen: '#008060',
    darkGreen2: '#00503C',
    darkLime: '#829623',
    lightGray: '#E0E0E0',
    osloGray: '#888a8d',
    purple: '#5F286F',
    purple2: '#A54BBE',
    purplePod: '#733DC2',
    bgPurplePod: '#8D61CE',
    red: '#D7454D',
    red2: '#D2373C',
    defaultCoral: '#D7464D',
    lightCoral: '#FAEFF4',
    silver: '#bdbdbd',
    silver2: '#878787',
    smoothGray: '#f8f8f8',
    white: '#ffffff',
    whiteLime: '#FAFAF0',
    yellow: '#F4D34D',
    lightYellow: '#BDD753',
    lightYellow2: '#ffff00',
    orange: '#f3970a',
    orange2: '#F67C0A',
    darkOrange: '#DD6752',
    whiteBlue: '#EBF5FF',
    blue: '#45A4E6',
    blue2: '#2896E1',
    blue3: '#006FA2',
    darkBlue: '#145F91',
    lightBlue: '#28B6F2',
    defaultGreen: '#0E7F61',
    darkerGreen: '#00503C',
    gray_F7: '#F7F7F7',
    gray_D7: '#D7D7D7',
    gray_C4: '#C4C4C4',
    gray_50: '#505050',
    gray_87: '#878787',
    gray_69: '#696969',
    sucess: '#14B88C',
    aqua: '#5AAFAF',
    darkAqua: '#376E6E',
    darkPurple: '#5F286E',
    gray: '#8D9AA9',
    limeAqua: '#09BEBC',
    lime: '#BDD753',
    lime2: '#C8DD52',
    lime3: '#FFDC51',
    lightGreen2: '#EBFFFA',
    gray_A5: '#A5A5A5',
    deepBlack: '#000000',
    vibrantLavender: '#8D61CE',
    emeraldGreen: '#1CE0B8',
    deepPurple: '#4D207D',
    deepTeal: '#015850',
    swampGreen: '#00AB85',
    vividOrange: '#FF9B14',
    royalPurple: '#7448AE',
    claret: '#871E23',
    darkTangerine: '#FF9204',
    coralRed: '#FF3D60',
    grayLight: '#F0F0F0',
    pink: '#CD3C7D'
}
